import { subscription } from './types';
export const subscribeToNewsletter = (payload) => {
  return {
    type: subscription.SUBSCRIBE_TO_NEWSLETTER,
    payload
  };
};
